<template>
    <div class="wrapper reveal-side-navigation">
        <div class="content clearfix">
            <!-- Full Width Slider Section -->
            <div class="section-block featured-media page-intro tm-slider-parallax-container">
                <div class="tm-slider-container full-width-slider">
                    <ul class="tms-slides">
                        <li class="tms-slide">
                            <div class="tms-content">
                                <div class="tms-content-inner center">
                                    <div class="row flex">
                                        <div class="column width-6 offset-3">
                                            <div>
                                                <h1 class="tms-caption mb-0 color-white animate__animated animate__slideInUp">Contact</h1>
                                                <div class="clear"></div>
                                                <p class="tms-caption lead mb-0 mb-mobile-20 color-white animate__animated animate__slideInUp">We would love to hear from you</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <img src="/images/slide.jpg" class="animate__animated animate__fadeIn animate__slow" />
                        </li>
                    </ul>
                </div>
            </div>
            <!-- Full Width Slider Section -->

            <!-- Contact Form -->
            <div class="section-block replicable-content contact-2 pt-50 pb-10">
                <div class="row">
                    <div class="column width-4">
                        <h3 class="mb-30">Talk To Us</h3>
                        <div class="row">
                            <div class="column width-10">
                                <p>
                                    Shoot us an email and tell us about your project or just say hello! We'll get back to
                                    you within 24hrs.
                                </p>
                            </div>
                        </div>
                        <div style="padding-top:15px">
                            <a
                                href="https://wa.me/447577107040"
                                class="button rounded medium no-margins bkg-red-light bkg-hover-black color-white color-hover-white weight-bold"
                                style="width:230px;text-align:center;display:flex;align-items:center;justify-content:center;"
                            >
                                <svg height="20px" viewBox="-23 -21 682 682.66669" width="20px" xmlns="http://www.w3.org/2000/svg">
                                    <path fill="#fff" d="m544.386719 93.007812c-59.875-59.945312-139.503907-92.9726558-224.335938-93.007812-174.804687 0-317.070312 142.261719-317.140625 317.113281-.023437 55.894531 14.578125 110.457031 42.332032 158.550781l-44.992188 164.335938 168.121094-44.101562c46.324218 25.269531 98.476562 38.585937 151.550781 38.601562h.132813c174.785156 0 317.066406-142.273438 317.132812-317.132812.035156-84.742188-32.921875-164.417969-92.800781-224.359376zm-224.335938 487.933594h-.109375c-47.296875-.019531-93.683594-12.730468-134.160156-36.742187l-9.621094-5.714844-99.765625 26.171875 26.628907-97.269531-6.269532-9.972657c-26.386718-41.96875-40.320312-90.476562-40.296875-140.28125.054688-145.332031 118.304688-263.570312 263.699219-263.570312 70.40625.023438 136.589844 27.476562 186.355469 77.300781s77.15625 116.050781 77.132812 186.484375c-.0625 145.34375-118.304687 263.59375-263.59375 263.59375zm144.585938-197.417968c-7.921875-3.96875-46.882813-23.132813-54.148438-25.78125-7.257812-2.644532-12.546875-3.960938-17.824219 3.96875-5.285156 7.929687-20.46875 25.78125-25.09375 31.066406-4.625 5.289062-9.242187 5.953125-17.167968 1.984375-7.925782-3.964844-33.457032-12.335938-63.726563-39.332031-23.554687-21.011719-39.457031-46.960938-44.082031-54.890626-4.617188-7.9375-.039062-11.8125 3.476562-16.171874 8.578126-10.652344 17.167969-21.820313 19.808594-27.105469 2.644532-5.289063 1.320313-9.917969-.664062-13.882813-1.976563-3.964844-17.824219-42.96875-24.425782-58.839844-6.4375-15.445312-12.964843-13.359374-17.832031-13.601562-4.617187-.230469-9.902343-.277344-15.1875-.277344-5.28125 0-13.867187 1.980469-21.132812 9.917969-7.261719 7.933594-27.730469 27.101563-27.730469 66.105469s28.394531 76.683594 32.355469 81.972656c3.960937 5.289062 55.878906 85.328125 135.367187 119.648438 18.90625 8.171874 33.664063 13.042968 45.175782 16.695312 18.984374 6.03125 36.253906 5.179688 49.910156 3.140625 15.226562-2.277344 46.878906-19.171875 53.488281-37.679687 6.601563-18.511719 6.601563-34.375 4.617187-37.683594-1.976562-3.304688-7.261718-5.285156-15.183593-9.253906zm0 0" fill-rule="evenodd"/>
                                </svg>
                                <strong style="margin-left:1rem;">+44 (0) 757 710 7040</strong>
                            </a>
                        </div>
                        <div style="padding-top:15px">
                            <a
                                href="tel:0333 344 6692"
                                class="button rounded medium no-margins bkg-red-light bkg-hover-black color-white color-hover-white weight-bold"
                                style="width:230px;text-align:center;"
                                onclick="return gtag_report_conversion('tel:03333446692')"
                            >
                                <strong>Call Us – 0333 344 6692</strong>
                            </a>
                        </div>
                        <div style="padding-top:15px;margin-bottom:20px;">
                            <a
                                href="javascript:void(Tawk_API.toggle())"
                                class="button rounded medium no-margins bkg-red-light bkg-hover-black color-white color-hover-white weight-bold"
                                style="width:230px;text-align:center;"
                            >
                                <strong>24 Hour Live Chat</strong>
                            </a>
                        </div>
                    </div>
                    <div class="column width-8 left">
                        <div id="email-form" class="contact-form-container">
                            <form action="/contact" method="post" novalidate>
                                <div class="row">
                                    <div class="column width-6">
                                        <div class="field-wrapper">
                                            <input
                                                v-model.trim="firstName"
                                                type="text"
                                                name="fname"
                                                class="form-fname form-element rounded medium"
                                                placeholder="First Name*"
                                                tabindex="1"
                                                required
                                            />
                                        </div>
                                    </div>
                                    <div class="column width-6">
                                        <div class="field-wrapper">
                                            <input
                                                v-model.trim="lastName"
                                                type="text"
                                                name="lname"
                                                class="form-lname form-element rounded medium"
                                                placeholder="Last Name"
                                                tabindex="2"
                                            />
                                        </div>
                                    </div>
                                    <div class="column width-6">
                                        <div class="field-wrapper">
                                            <input
                                                v-model.trim="email"
                                                type="email"
                                                name="email"
                                                class="form-email form-element rounded medium"
                                                placeholder="Email address*"
                                                tabindex="3"
                                                required
                                            />
                                        </div>
                                    </div>
                                    <div class="column width-6">
                                        <div class="field-wrapper">
                                            <input
                                                v-model.trim="telephone"
                                                type="tel"
                                                name="telephone"
                                                class="form-email form-element rounded medium"
                                                placeholder="Telephone number*"
                                                tabindex="4"
                                                required
                                            />
                                        </div>
                                    </div>
                                    <div class="column width-6">
                                        <div class="form-select form-element rounded medium">
                                            <select
                                                v-model="reasonForEmailing"
                                                tabindex="6"
                                                class="form-aux"
                                            >
                                                <option disabled value="">Reason for Emailing</option>
                                                <option>General Enquiry</option>
                                                <option>Regarding an existing order</option>
                                                <option>Regarding a missing order</option>
                                                <option>Business Partnership</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="column width-12">
                                        <div class="field-wrapper pt-10 pb-10">
                                            <input v-model.trim="customer"
                                                id="radio-1"
                                                class="form-element radio"
                                                name="radio-group"
                                                type="radio"
                                                value="is customer"
                                            />
                                            <label for="radio-1" class="radio-label">I'm an AiroLuggage customer</label>
                                            <input v-model.trim="customer"
                                                id="radio-2"
                                                class="form-element radio"
                                                name="radio-group"
                                                type="radio"
                                                value="is not customer"
                                            />
                                            <label for="radio-2" class="radio-label">I'm not an AiroLuggage customer</label>
                                        </div>
                                    </div>
                                    <div class="column width-6">
                                        <input
                                            type="text"
                                            name="honeypot"
                                            class="form-honeypot form-element rounded medium"
                                        />
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="column width-12">
                                        <div class="field-wrapper">
                                            <textarea
                                                v-model.trim="message"
                                                name="message"
                                                class="form-message form-element rounded medium"
                                                placeholder="Message*"
                                                tabindex="7"
                                                required
                                            ></textarea>
                                        </div>
                                    </div>
                                    <div class="column width-12">
                                        <div class="field-wrapper pt-10 pb-10">
                                            <input
                                                 v-model="acceptTerms" 
                                                id="checkbox-1"
                                                class="form-element checkbox"
                                                name="checkbox-1"
                                                type="checkbox"
                                                required
                                            />
                                            <label for="checkbox-1" class="checkbox-label">
                                                I agree to the terms &amp;
                                                conditions.
                                            </label>
                                        </div>
                                    </div>
                                    <div class="column width-12">
                                        <input @click.prevent="send" :disabled="disableSubmitButton"
                                            type="submit"
                                            value="Send Email to Airoluggage"
                                            class="form-submit button rounded medium bkg-theme bkg-hover-theme color-white color-hover-white"
                                        />
                                    </div>
                                    <div align="center" v-if="messageSending">
                                        <h3>Please wait, sending message....</h3>
                                        <scale-loader :loading="messageSending" ></scale-loader>
                                    </div>
                                    <div class="box alert" v-if="messageFailedToSend">
                                        <h2>Sorry but for some reason the attempt to send the message has failed.</h2>
                                    </div>
                                    <div class="box success" v-if="messageSent">
                                        <h2>Thank you, we have received your message.</h2>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <!--Contact Form End -->

            <!-- Hero 5 Section -->
            <div
                class="section-block hero-5 right show-media-column-on-mobile bkg-gradient-purple-haze"
                style="padding-top:40px; height: 60rem"
            >
                <div class="media-column width-6">
                    <iframe
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2482.2349548630314!2d-0.0911794484965038!3d51.52725027953841!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x48761dd661009dff%3A0xd5c0ae8f845b5887!2sAiroLuggage%20-%20Luggage%20Delivery%20Company!5e0!3m2!1sen!2suk!4v1598278704246!5m2!1sen!2suk"
                        width="800"
                        height="600"
                        frameborder="0"
                        style="border:0;"
                        allowfullscreen
                        aria-hidden="false"
                        tabindex="0"
                    ></iframe>
                    <!-- <div
                        class="map-container"
                        data-coordinates="[[51.5272503,-0.0911741]]"
                        data-icon="/images/map-marker.png"
                        data-info="London office<br>160 City Road"
                        data-zoom-level="16"
                        data-style="greyscale"
                    >
                        <div id="map-canvas"></div>
                    </div>-->
                </div>
                <div class="row">
                    <div class="column width-5">
                        <div class="hero-content split-hero-content">
                            <div class="hero-content-inner left">
                                <h3 class="mb-30 color-white">Locations</h3>
                                <div class="column width-6 contact-column" style="padding-left:0px">
                                    <p class="color-white">
                                        <u>London Office (Head Office)</u>
                                        <br />160 City
                                        Road,
                                        <br />London,
                                        <br />EC1V 2NX.
                                    </p>
                                    <p class="color-white">
                                        <u>Glasgow Office</u>
                                        <br />2/3, 48 West George
                                        St.,
                                        <br />Glasgow,
                                        <br />G2 1BP.
                                    </p>
                                    <p class="color-white">
                                        <u>Birmingham Office</u>
                                        <br />Blackthorn House,
                                        <br />St Paul's
                                        Square,
                                        <br />Birmingham,
                                        <br />B3 1RL.
                                    </p>
                                </div>
                                <div
                                    class="column width-6 contact-column right"
                                    style="padding-left:0px;padding-right:0px;"
                                >
                                    <p class="mb-10 color-white">
                                        <strong>Opening Hours</strong>
                                    </p>
                                    <p class="color-white">
                                        9:00 am - 17:30 pm
                                        <br />Monday to Friday
                                      <br>Closed Saturday and Sunday
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Hero 5 Section End -->
        </div>
        <!-- Content End -->
    </div>
</template>

<script>

import ScaleLoader from 'vue-spinner/src/ScaleLoader.vue'

export default {
  metaInfo: {
    link: [
      {rel: 'canonical', href: 'https://airoluggage.com/contact'}
    ]
  },
    data() {
        return {
            firstName: '',
            lastName: '',
            email: '',
            telephone: '',
            reasonForEmailing: '',
            customer: '',
            message: '',
            acceptTerms: false,

            messageSending: false,
            messageSent: false,
            messageFailedToSend: false,
        };
    },
    computed: {
        disableSubmitButton: function() { return this.messageSending /*|| this.messageSent*/; },
    },
    components: {
        ScaleLoader
    },
    methods: {
        async send() {
            this.messageSending = true;
            this.messageSent = false;
            this.messageFailedToSend = false;
            // console.log(this.firstName);
            // console.log(this.lastName);
            // console.log(this.email);
            // console.log(this.telephone);
            // console.log(this.reasonForEmailing);
            // console.log(this.customer);
            // console.log(this.message);
            // console.log(this.acceptTerms);

            const result = await this.$store.dispatch('pricing/contact_sendmsg', {
                firstName: this.firstName,
                lastName: this.lastName,
                email: this.email,
                telephone: this.telephone,
                reasonForEmailing: this.reasonForEmailing,
                customer: this.customer,
                message: this.message,
                acceptTerms: this.acceptTerms
            });
            this.messageSending = false;
            if (result.success) {
                this.messageSent = true;
            }
            else {
                this.messageFailedToSend = true;
                console.error(result.error);
            }
        }
    }
};
</script>

<style lang="css" scoped>
.tms-slide {
    visibility: visible;
}
.tms-slide img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.tms-caption {
    opacity: 1;
}

</style>
